import BaseModel from './BaseModel';
import eventival from '../assets/images/integrations/eventival.png';
import kronos from '../assets/images/integrations/kronos.png';
import json from '../assets/images/integrations/json.png';
import own_it from '../assets/images/integrations/own_it.png';
import shift72 from '../assets/images/integrations/shift72.png';

/** Class representing a Ref. */
class Ref extends BaseModel {
    icone = () => {
        if (this.source === 'eventival')
            return eventival;
        if (this.source === 'kronos')
            return kronos;
        if (this.source === 'json')
            return json;
        if (this.source === 'dac-player')
            return own_it;
        if (this.source === 'shift72')
            return shift72;

        return null;
    }

    display = () => {
        return [this.id, this.name].filter(Boolean).join(' - ');
    }
}

export default Ref;
